import React, { useId } from 'react';
import './styles.scss';

// A small Studio tile (the scenes' core chip, light sweeping its rim) whose chart
// grows on a loop: the bars rise, the trend line draws itself in the AI colours and
// its arrow lands. Decorative and CSS only; reduced motion sees it fully drawn.
export default function GrowthBadge() {
  const gradient = `studio-growth-${useId().replace(/:/g, '')}`;
  return <span className="studio-landing-growth" aria-hidden="true">
    <span className="studio-landing-growth__rim"><span className="studio-landing-growth__sweep" /></span>
    <span className="studio-landing-growth__bevel">
      <span className="studio-landing-growth__face">
        <svg viewBox="0 0 32 32" focusable="false">
          <defs>
            <linearGradient id={gradient} x1="0" y1="1" x2="1" y2="0">
              <stop offset="0%" className="is-cool" />
              <stop offset="55%" className="is-violet" />
              <stop offset="100%" className="is-warm" />
            </linearGradient>
          </defs>
          <rect className="studio-landing-growth__bar" x="5" y="20" width="4.5" height="7" rx="1.2" />
          <rect className="studio-landing-growth__bar" x="13.75" y="16" width="4.5" height="11" rx="1.2" />
          <rect className="studio-landing-growth__bar" x="22.5" y="12" width="4.5" height="15" rx="1.2" />
          <path className="studio-landing-growth__trend" d="M4 21 L11 14.5 L16 17.5 L27 6.5" pathLength="1" stroke={`url(#${gradient})`} />
          <path className="studio-landing-growth__arrow" d="M21.5 6.5 H27 V12" stroke={`url(#${gradient})`} />
        </svg>
      </span>
    </span>
  </span>;
}
